import { createProgressMessage } from 'src/utils/voicebox/messages';

export const INITIAL_NEW_MODEL_PROGRESS_MESSAGE = createProgressMessage({
  content: `
Hi! I'm Voicebox and I am here to help you create an initial data model for your Knowledge Graph!
Simply describe the data model you need.
Be as specific as possible.
"C360" is ok, "C360 for customer satisfaction" is better, but, "C360 for an ecommerce retailer trying to improve customer satisfaction. the primary concepts are ..." is best.
The more details you provide, the better the starter model will be.
`.trim(),
});

export const createNewModelPrompt = ({
  defaultNamespace,
  userPrompt,
}: {
  defaultNamespace: string;
  userPrompt: string;
}) => {
  return (
    `Please provide a Stardog Data Model, without any other explanation or information that was not requested, ` +
    `serialized as Turtle code, that uses the base, empty ("") namespace ` +
    `with the IRI "${defaultNamespace}" as the default to define its classes and properties, that describes ${userPrompt}.`
  );
};
